
import React, { useState } from 'react';
import './ContactUs.css';

const ContactUs = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !email || !message) {
      setStatus('Please fill in all fields.');
      return;
    }

    setStatus('Sending...');

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name, email, message }),
      });

      if (response.ok) {
        setStatus('Thank you for your message!');
        setName('');
        setEmail('');
        setMessage('');
      } else {
        const errorData = await response.json();
        setStatus(errorData.detail || 'An error occurred. Please try again.');
      }
    } catch (error) {
      console.error('Contact form submission error:', error);
      setStatus('An error occurred. Please check your connection and try again.');
    }
  };

  return (
    <>
      <title>Contact Us - WizeHelper</title>
      <div className="contact-us-container">
      <div className="contact-us-card">
        <h1 className="contact-us-title">Contact Us</h1>
        <p className="contact-us-subtitle">
          Have a question or feedback? Fill out the form below to get in touch with us.
        </p>
        <form onSubmit={handleSubmit} className="contact-us-form">
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Your Name"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your.email@example.com"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Your message..."
              rows="6"
              required
            ></textarea>
          </div>
          <button type="submit" className="submit-button">Send Message</button>
        </form>
        {status && <p className="status-message">{status}</p>}
      </div>
    </div>
    </>
  );
};

export default ContactUs;
